import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';
import { getToggleAllDayState } from 'clevertap/hourFilter';

export function reportGrossProfitStart({ grossProfit }) {
  pushClevertapEvent('Report Gross Profit Start', {
    'Cost of Goods Sold': grossProfit.cogs,
    Discounts: grossProfit.discount,
    Refunds: grossProfit.refund,
    'Net Sales': grossProfit.netSales,
    'Gross Profit': grossProfit.grossProfit,
    'Gross Sales': grossProfit.grossSales,
  });
}

export function reportGrossProfitHoverCOGSAdj() {
  pushClevertapEvent('Report Gross Profit Hover COGS Adj', {});
}

export function reportGrossProfitExport({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Report Gross Profit Export', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportGrossProfitPerOutletExport({
  outletIds,
  startDate,
  endDate,
}) {
  pushClevertapEvent('Report Gross Profit Per Outlet Export', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}
